import { render, staticRenderFns } from "./temporada.vue?vue&type=template&id=a5f91bf2&scoped=true"
import script from "./temporada.vue?vue&type=script&lang=js"
export * from "./temporada.vue?vue&type=script&lang=js"
import style0 from "./temporada.vue?vue&type=style&index=0&id=a5f91bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f91bf2",
  null
  
)

export default component.exports